























































import {Component, Vue} from 'vue-property-decorator';
import {
  Action,
  Getter,
} from 'vuex-class';

import {mapActions} from 'vuex';

@Component
export default class SignUp extends Vue {
  public $refs!: {
    form: any,
  };

  private user: any = {};
  private loading: boolean = false;
  @Getter('common/rules/all') private rules!: any;
  @Getter('guest/auth/username') private username!: any;
  @Getter('guest/auth/password') private password!: any;

  @Action('guest/auth/signIn') private signIn!: any;
  @Action('guest/auth/resendSignUp') private resendSignUp!: any;
  @Action('guest/auth/confirmSignUp') private confirmSignUp!: any;

  private mounted() {
    if (this.username) {
      this.user.username = this.username;
      this.user.password = this.password;
    }
  }

  private async Confirm(e) {
    e.preventDefault();
    if (this.$refs.form.validate()) {
      this.loading = true;
      const res = await this.confirmSignUp(this.user);
      if (res) {
        if (this.user.password && await this.signIn(this.user)) {
          this.$router.push({name: 'UserBase'});
        } else {
          this.$router.push({name: 'SignIn'});
        }
      }
      this.loading = false;
    }
  }

  private async Resend(e) {
    e.preventDefault();
    this.loading = true;
    await this.resendSignUp(this.user);
    this.loading = false;
  }
}
